import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { ButtonStyled } from './styles';

export default function ErrorMessageWithButton({
  message,
  hasButton = false,
  buttonText,
  onClick,
  disabled = false
}) {
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      width="100%"
    >
      <Stack
        alignItems="center"
        direction="row"
        gap="8px"
      >
        <SharedAsset
          alt=""
          src="/icon/micro/alert-fill.svg"
        />
        <Text
          aria-label="Error message"
          color="red"
          size="md"
        >
          {message}
        </Text>
      </Stack>
      {hasButton && (
        <ButtonStyled
          color="info"
          disabled={disabled}
          onClick={onClick}
          variant="text"
        >
          {buttonText}
        </ButtonStyled>
      )}
    </Stack>
  );
}

ErrorMessageWithButton.propTypes = {
  message: PropTypes.string,
  hasButton: PropTypes.bool,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};
